<template>
    <div class="alert-container" v-if="messages && messages.length > 0">
        <transition-group name="message" tag="div">
            <AlertMessage 
                v-for="(msg, i) in messages" 
                :type="msg.type" 
                :message="msg.message" 
                :time="msg.time"
                :transition="msg.transition" 
                :onDict="msg.onDict" 
                :pos="i" 
                :key="i+1" 
            />
        </transition-group>
    </div>
</template>

<script>
import AlertMessage from "./AlertMessage.vue";

export default {
    // Type = Tipos de alertas: error, success, alert
    props: {
        messages: {
            type: Array,
            default: _ => []
        }
    },
    provide() {
        return {
            container: this
        };
    },
    data() {
        return {
            alertType: "",
            show: false
        };
    },
    components: {
        AlertMessage
    },
};
</script>

<style lang="scss" scoped>
.alert-container {
    width: 300px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 11000;
}
</style>
